import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { AppForm, FormDatePicker, FormInput } from "@/shared/Components";
import { FormButtonSelect } from "@/shared/Components/Form/FormButtonSelect";
import type { UseFormReturn } from "react-hook-form";
import type { Person } from "@/services/api";
import type { PersonInfoCardFormValues } from "@/entities/person-info-card/model";
import styles from "./styles.module.scss";

export const InfoEdit = ({
  currentPerson,
  form,
  onSubmit,
}: {
  currentPerson: Person;
  form: UseFormReturn<PersonInfoCardFormValues>;
  onSubmit: (data: PersonInfoCardFormValues) => Promise<void>;
}) => {
  const { t } = useTranslation();

  const handleBlur = useCallback(() => {
    form.handleSubmit(onSubmit)();
  }, [form, onSubmit]);

  return (
    <AppForm formApi={form} className={styles.root}>
      <FormInput
        name="firstName"
        placeholder={t("contactsPage.generalInfo.firstName")}
        onBlur={handleBlur}
      />
      <FormInput
        name="middleName"
        placeholder={t("contactsPage.generalInfo.middleName")}
        onBlur={handleBlur}
      />
      <FormInput
        name="lastName"
        placeholder={t("contactsPage.generalInfo.lastName")}
        onBlur={handleBlur}
      />
      <FormButtonSelect
        placeholder={t("common.gender")}
        name="gender"
        allowClear
        options={[
          { label: t("common.male"), value: "MALE" },
          { label: t("common.female"), value: "FEMALE" },
          { label: t("common.notDefined"), value: "NOT_DEFINED" },
        ]}
        onBlur={handleBlur}
      />
      <FormDatePicker
        isOnlyYearPicker={!currentPerson?.birthdaySDate?.year}
        hideOnlyYearCheckbox={false}
        placeholder={t("settingsPage.general.birthday")}
        name="birthday"
        customOnChange={handleBlur}
      />
    </AppForm>
  );
};
